import styled, { css } from 'styled-components'
import theme from 'live/services/theme'

export const Container = styled.div`
    ${({ empty }: { empty?: boolean }) =>
        !empty &&
        css`
            div {
                background: ${theme['dash-background']};
            }
        `};
    div {
        min-height: 30px;
        text-align: center;
        padding: 10px;
        font-size: 14px;
    }
`
